import React from 'react'
import HeroSection from '../components/HeroSection'
import "./page.css"
import Sidebar from '../components/Sidebar'
import { useState } from 'react'
import Roadmap from '../components/Roadmap'
import Info1 from '../components/Info'
import { ObjOne } from '../components/Info/Data'
import Citizen from '../components/Citizenship'
import Buy from '../components/Buy'
import SubFaq from '../components/Faq/SubFaq'
import Team from '../components/Team'
import Contact from '../components/Contact'
import Bottom from '../components/Bottom'
import Comics from '../components/Comics'
import Gallery from '../components/Gallery'

const Home = () => {

const [isOpen, setIsOpen] = useState(false)

const toggle = () => {

    setIsOpen(!isOpen)
    
}
    return (
        <div className="toall">
        <Sidebar isOpen={isOpen} toggle = { toggle }/>
        <HeroSection toggle = { toggle }/>
        <Gallery />
        {/* <Comics /> */}
        <Info1 {...ObjOne}/>
        <Citizen/>
        <Roadmap/>
        <Buy />
        
        <SubFaq />
        <Team />
        <Contact />
        <Bottom />
        {/* <Faq /> */}
        
        </div>
    )
}

export default Home
